import React, { useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  TextField,
  Typography,
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'

import SaveIcon from '@mui/icons-material/Save'
import SaveAsIcon from '@mui/icons-material/SaveAs'

import { DataGrid, esES } from '@mui/x-data-grid'

const Virtues = (props) => {
  const { firestore } = useFirebase()
  const {
    addDocToCollection, 
    deleteDocFromCollection,
    updateDocFromCollection, 
    getVirtues, 
    virtues 
  } = firestore

  const [loading, setLoading] = useState(false)

  const [rows, setRows] = useState([])

  const columns = [
    // { field: 'id', headerName: 'ID', width: 70 },
    { 
      field: 'name', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Nombre'}</b>
      ),
      renderCell: (params) => {
        return <b style={{ fontWeight: 'bold' }}>{params.value}</b>
      },
      minWidth: 160,
      flex: 1,
    },
    { 
      field: 'description', 
      renderHeader: (params) => (
        <b style={{ fontWeight: '900' }}>{'Descripción'}</b>
      ), 
      minWidth: 480,
      flex: 3,
    },
    // { 
    //   field: 'guia', 
    //   headerName: 'Guía', 
    //   width: 130, 
    //   renderCell: (params) => {
    //     return <Button component='a' href={params.value} target='_blank' disabled={params.value === ''} variant='contained' disableElevation size='small'>{params.value === '' ? 'No disponible' : 'Ver'}</Button>
    //   }
    // },
  ]

  useEffect(() => {
    getVirtues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (virtues === undefined) return

    var data = []
    virtues.forEach((virtue) => {
      data.push({
        'id': virtue['id'],
        'name': virtue['name'],
        'description': virtue['description']
      })
    })
    setRows(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [virtues])

  const [name, setName] = useState('')
  const handleNameChanged = (event) => {
    setName(event.target.value)
  }

  const [description, setDescription] = useState('')
  const handleDescriptionChanged = (event) => {
    setDescription(event.target.value)
  }

  const [selectionModel, setSelectionModel] = useState([])

  const handleRowClick = (event) => {
    const id = event.id
    const row = event.row
    if (selectionModel.includes(id)) {
      clear()
    } else {
      setName(row.name)
      setDescription(row.description)
    }
  }

  const clear = () => {
    setSelectionModel([])
    setName('')
    setDescription('')
  }

  const onCreateOrEdit = async () => {
    setLoading(true)
    
    const data = {
      'name': name,
      'description': description
    }

    if (selectionModel.length === 0) {
      await addDocToCollection('virtues', data)
    } else {
      const id = selectionModel[0]
      await updateDocFromCollection('virtues', id, data)
    }

    clear()
    setLoading(false)
  }

  const onDelete = async () => {
    const id = selectionModel[0]
    await deleteDocFromCollection('virtues', id)
    clear()
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography color='primary' variant='h4'>
          <b style={{ fontWeight: 900 }}>Virtudes</b>
        </Typography>
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1' gutterBottom>
                  <b style={{ fontWeight: 900 }}>{selectionModel.length > 0 ? 'EDITAR' : 'NUEVA'} VIRTUD</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={name}
                  onChange={handleNameChanged}
                  placeholder='Nombre de la virtud'
                  label='Nombre'
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  value={description}
                  onChange={handleDescriptionChanged}
                  placeholder='Describe la virtud'
                  label='Descripción'
                  InputLabelProps={{ shrink: true }}
                  multiline
                  maxRows={6}
                  fullWidth
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions sx={{ justifyContent: 'end', p: 0, pt: 2 }}>
            {
              selectionModel.length > 0 ? (
                <Button color='warningRed' disableElevation variant='contained' onClick={onDelete} sx={{ mr: 'auto' }}>
                  <b style={{ fontWeight: 900 }}>BORRAR</b>
                </Button>
              ) : null
            }
            {
              name !== '' || description !== '' ? (
                <Button color='secondary' disableElevation variant='contained' onClick={clear}>
                  <b style={{ fontWeight: 900 }}>CANCELAR</b>
                </Button>
              ) : null
            }
            <LoadingButton disabled={ name === '' || description === '' } color='primary' disableElevation variant='contained' onClick={onCreateOrEdit} loading={loading} loadingPosition='start' startIcon={loading ? <SaveAsIcon /> : <SaveIcon />}>
              {
                loading ? <b style={{ fontWeight: 900 }}>{selectionModel.length > 0 ? 'EDITANDO' : 'CREANDO'}</b> : <b style={{ fontWeight: 900 }}>{selectionModel.length > 0 ? 'EDITAR' : 'CREAR'}</b>
              }
            </LoadingButton>
          </CardActions>
        </Card>
      </Grid>
      <Grid item xs={12} md={6} lg={8}>
        <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography color='primary' variant='body1'>
                  <b style={{ fontWeight: 900 }}>LISTA DE VIRTUDES</b>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  autoHeight
                  // disableColumnMenu
                  columns={columns}
                  localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                  pageSize={10}
                  rows={rows}
                  rowsPerPageOptions={[10]}
                  sx={{ borderWidth: 0 }}
                  onRowClick={handleRowClick}
                  onSelectionModelChange={setSelectionModel}
                  selectionModel={selectionModel} 
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default Virtues